import { motion } from 'framer-motion';
import { Code, Database, Cloud, Cpu, Zap, Camera } from 'lucide-react';
import { Card } from '../ui/card';
import { Progress } from '../ui/progress';

export const SkillsWindow = () => {
  const skillCategories = [
    {
      icon: Code,
      title: 'Frontend Development',
      color: 'text-primary',
      skills: [
        { name: 'React / Next.js', level: 92 },
        { name: 'JavaScript / TypeScript', level: 90 },
        { name: 'HTML5 / CSS3', level: 95 },
        { name: 'Tailwind CSS', level: 88 }
      ]
    },
    {
      icon: Database,
      title: 'Backend & Automation',
      color: 'text-accent',
      skills: [
        { name: 'Node.js', level: 85 },
        { name: 'Python / Discord.py', level: 90 },
        { name: 'Discord.js', level: 93 },
        { name: 'REST APIs', level: 82 }
      ]
    },
    {
      icon: Cpu,
      title: 'Event Technology',
      color: 'text-success',
      skills: [
        { name: 'Technical', level: 95 },
        { name: 'Sound & Light Engineering', level: 94 },
        { name: 'Stage & Visual Systems', level: 90 },
        { name: 'Audiovisual Production', level: 92 }
      ]
    },
    {
      icon: Camera,
      title: 'Creative Media',
      color: 'text-primary',
      skills: [
        { name: 'Professional Photography', level: 88 },
        { name: 'Video Editing', level: 91 },
        { name: 'Digital Media Strategy', level: 85 },
        { name: 'Content Development', level: 87 }
      ]
    },
    {
      icon: Cloud,
      title: 'Leadership & Ops',
      color: 'text-accent',
      skills: [
        { name: 'Event Operations', level: 96 },
        { name: 'Technical Direction', level: 94 },
        { name: 'Public Speaking', level: 85 },
        { name: 'Financial Planning', level: 80 }
      ]
    },
    {
      icon: Zap,
      title: 'Languages',
      color: 'text-success',
      skills: [
        { name: 'Malayalam (Fluent)', level: 100 },
        { name: 'English (Fluent)', level: 95 },
        { name: 'Arabic (Basic)', level: 45 },
        { name: 'Hindi (Basic)', level: 40 },
        { name: 'Tamil (Basic)', level: 35 }
      ]
    }
  ];

  return (
    <div className="space-y-6">
      {/* Header */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <h1 className="text-4xl font-bold glow-text mb-2">Technical Skills</h1>
        <p className="text-muted-foreground">Comprehensive overview of my technical expertise in Development, Media, and Event Tech</p>
      </motion.div>

      {/* Skills Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {skillCategories.map((category, i) => (
          <motion.div
            key={category.title}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.1 }}
          >
            <Card className="p-6 tech-border h-full">
              <div className="flex items-center gap-3 mb-4">
                <div className={`p-2 rounded-lg bg-primary/10`}>
                  <category.icon className={`w-5 h-5 ${category.color}`} />
                </div>
                <h3 className="font-bold text-lg">{category.title}</h3>
              </div>
              <div className="space-y-4">
                {category.skills.map((skill, j) => (
                  <div key={skill.name} className="space-y-2">
                    <div className="flex justify-between text-sm">
                      <span className="text-foreground">{skill.name}</span>
                      <span className="text-muted-foreground">{skill.level}%</span>
                    </div>
                    <Progress value={skill.level} className="h-2" />
                  </div>
                ))}
              </div>
            </Card>
          </motion.div>
        ))}
      </div>
{/* Key Roles & Recognitions */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.6 }}
      >
        <Card className="p-6 tech-border">
          <h3 className="text-xl font-bold text-primary mb-4">Key Roles & Achievements</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {[
              'Founder & CEO - Pinnacle Event Organizing',
              'Head of Event Operations - TEDxSISJ Youth',
              'Technical Director - SISJ Student Council',
              'Radio Club President - Sharjah Indian School',
              'Technical Lead - SIS FEST\'24',
              'Head of Tech & Media - CSMS Season 3',
              'Joint Secretary - Social Awareness Club',
              'Deputy Advisor - Social Awareness Club',
              'Assistant Event Organizer - Ebae Club',
              'Freelance Full Stack Developer',
              'Freelance Sound & Light Engineer'
            ].map((achievement, i) => (
              <div key={i} className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-full bg-success" />
                <span className="text-sm text-foreground/80">{achievement}</span>
              </div>
            ))}
          </div>
        </Card>
      </motion.div>
    </div>
  );
};

export default SkillsWindow;